function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M16 8C16 12.4192 12.4184 16 8 16C3.5816 16 0 12.4192 0 8C0 3.5824 3.5816 0 8 0C12.4184 0 16 3.5824 16 8Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M10.859 11.0526C10.7542 11.0526 10.6486 11.0254 10.5518 10.9686L7.41096 9.09501C7.23016 8.98621 7.11896 8.79021 7.11896 8.57901V4.54141C7.11896 4.21021 7.38776 3.94141 7.71896 3.94141C8.05016 3.94141 8.31896 4.21021 8.31896 4.54141V8.23821L11.167 9.93661C11.451 10.107 11.5446 10.475 11.375 10.7598C11.2622 10.9478 11.063 11.0526 10.859 11.0526Z",
  fill: "#C4C4C4"
});

function SvgTransaction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/Transaction.16f8098c.svg";
export { ForwardRef as ReactComponent };